import spriteMarkup from '../../assets/icons/sprite.svg?raw';

export type IconName =
  | 'logo'
  | 'info-share'
  | 'files'
  | 'file'
  | 'sms'
  | 'sedr'
  | 'settings'
  | 'audit-log'
  | 'disk-usage'
  | 'lock'
  | 'unlock'
  | 'key'
  | 'shield'
  | 'warning'
  | 'user'
  | 'password'
  | 'hourglass'
  | 'sun'
  | 'moon'
  | 'help-circle'
  | 'menu'
  | 'x'
  | 'sealed'
  | 'guest'
  | 'fingerprint'
  | 'link'
  | 'req-links'
  | 'panel-left'
  | 'maximize'
  | 'minimize'
  | 'chevron-down'
  | 'chevron-up'
  | 'chevron-left'
  | 'plus'
  | 'file-download'
  | 'filter';

let spriteInjected = false;

/** Inline the icon sprite so <use> references work in Firefox (external sprites break stroke/currentColor). */
function ensureSprite(): void {
  if (spriteInjected) return;
  spriteInjected = true;

  const doc = new DOMParser().parseFromString(spriteMarkup, 'image/svg+xml');
  const root = doc.documentElement;
  root.id = 'shareweb-icon-sprite';
  root.setAttribute('aria-hidden', 'true');
  root.style.display = 'none';
  document.body.prepend(root);
}

export function icon(name: IconName, options?: { label?: string; className?: string }): SVGSVGElement {
  ensureSprite();

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.classList.add('icon');
  svg.setAttribute('viewBox', '0 0 24 24');
  if (options?.className) {
    svg.classList.add(...options.className.split(' '));
  }

  if (options?.label) {
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', options.label);
  } else {
    svg.setAttribute('aria-hidden', 'true');
  }

  const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttribute('href', `#icon-${name}`);
  svg.append(use);
  return svg;
}

export function iconImg(name: IconName, size = 20): HTMLSpanElement {
  const wrap = document.createElement('span');
  wrap.className = 'icon-wrap';
  const svg = icon(name);
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  wrap.append(svg);
  return wrap;
}
